export enum SourcesIds {
  marketplace = '1',
  landings = '2',
}
